
import moment from "moment";
import "moment-timezone";
export class NotificationTransformer {
  static transform(obj) {
    return {
      id: obj.id,
      type: obj.type,
      model: obj.attributes.notification_type,
      notifiableType: obj.attributes.notifiable_type,
      notifiableId: obj.attributes.notifiable_id,
      subtype: obj.attributes.subtype,
      recipientId: obj.attributes.recipient_id,
      recipient: obj.attributes.recipient,
      status: obj.attributes.status,
      data: obj.attributes.data,
      createdAt: obj.attributes.created_at
    };
  }
}



// WEBPACK FOOTER //
// ./src/helpers/notifications/notification.transformer.js